import { createFileRoute } from "@tanstack/react-router";

import { EngagementThread } from "~/components/messaging/engagement-thread";

export const Route = createFileRoute(
  "/_user/my-coaching/clients/programs/$engagementId/messages",
)({
  staticData: { title: "Messages" },
  component: RouteComponent,
});

function RouteComponent() {
  const { engagementId } = Route.useParams();
  return <EngagementThread engagementId={engagementId} />;
}
